import { Pipe, PipeTransform } from '@angular/core';
import { Reclamation } from '../../modules/reclamation/models/reclamation';
import { User } from '../../modules/auth/models/user.model';

@Pipe({
  name: 'changestatus'
})
export class changestatusPipe implements PipeTransform {

  transform(stat: string,reclamation:Reclamation,user:User,actiondate:number): string {

    let returnedstat:string
    let acq=false
    let eme=false
    //@ts-ignore
  user.usertype!='Clientpor'&&user.usertype!='Clientcomm'&&reclamation.transactions[0].ISSUERBANKIDENTIFICATION==reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION?eme=acq=true:''
  //@ts-ignore
  user.usertype!='Clientpor'&&user.usertype!='Clientcomm'&&reclamation.transactions[0].ISSUERBANKIDENTIFICATION==user.banque&&reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION!=user.banque?(eme=true,acq=false):''
  //@ts-ignore
  user.usertype!='Clientpor'&&user.usertype!='Clientcomm'&&reclamation.transactions[0].ISSUERBANKIDENTIFICATION!=user.banque&&reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION==user.banque?(acq=true,eme=false):''
  //console.log(eme,acq,stat1,stat2)
  //@ts-ignore
let filtredstatut= reclamation.statut.filter(e=>!e.etat&&e.date<actiondate)
console.log(filtredstatut)
//@ts-ignore
let stat1=filtredstatut[filtredstatut.length-1]?.item
//@ts-ignore
let stat2=filtredstatut[filtredstatut.length-2]?.item
//@ts-ignore
let stat3=filtredstatut[filtredstatut.length-3]?.item
//@ts-ignore
let role1=filtredstatut[filtredstatut.length-1]?.role
//@ts-ignore
let role2=filtredstatut[filtredstatut.length-2]?.role
//@ts-ignore
let role3=filtredstatut[filtredstatut.length-3]?.role
  //@ts-ignore
let batchstat= reclamation.statut.find(e=>!e.etat&&e.item==stat&&e.role=='batch')
if (batchstat) {
  const batchstatIndex = reclamation.statut.findIndex(e => e === batchstat);

  // Get the object just before batchstat if it exists
  const previousStat = batchstatIndex > 0 ? reclamation.statut[batchstatIndex - 1] : null;
  const prepreviousStat = batchstatIndex > 0 ? reclamation.statut[batchstatIndex - 2] : null;
  const preprepreviousStat = batchstatIndex > 0 ? reclamation.statut[batchstatIndex - 3] : null;

  if (previousStat) {
      stat=previousStat.item
stat1=prepreviousStat?.item
stat2=preprepreviousStat?.item
role1=prepreviousStat?.role
role2=preprepreviousStat?.role
  } else {
      console.log('No object exists before the batchstat in the array.');
  }
} else {
  console.log('Batchstat not found in the array.');
}
//console.log(stat1)
//console.log(stat)

  //comité arbitrage
  user.usertype=='comite arbitrage'?returnedstat=stat:
    
    //statuts commerçant
    user.usertype=='Clientcomm'?
    stat=='crée'?returnedstat='créée':
    stat=='rejetée'&&stat1=='crée'?returnedstat='rejetée':
    stat=='rejetée'&&stat1=='rechdoc'?returnedstat='rejetée':
    stat=='rejetée'&&!stat1?returnedstat='rejetée':
    stat=='clôturé'?returnedstat='clôturé':
    stat=='rejetée'&&stat1=='reponserechdoc'?returnedstat='Réponse demande de document':
    stat=='reponserechdoc'?returnedstat='Réponse dde doc reçue':
    //@ts-ignore
    stat=='rechdoc'&&reclamation.transactions[0].ISSUERBANKIDENTIFICATION==reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION?returnedstat='chargeback':
    stat=='rechdoc'?returnedstat='Dde Doc reçu':
    stat=='chb émis'?returnedstat='Impayé Réçu':
    stat=='acceptée'&&stat1=='chb émis'?returnedstat='chb accepté':
    stat=='rejetée'&&stat1=='chb émis'?returnedstat='Représentée':
    stat=='rejetée'&&stat1=='rejetée'?returnedstat='rejetée':
  stat=='relancée'&&stat1=='rejetée'?returnedstat='Représentée':
 // stat=='clôturé'&&stat1=='relancée'&&stat2=='rejetée'?returnedstat='Représentée':
  stat=='pré-arbitrage'?returnedstat='pré-arbitrage reçu':
  stat=='acceptée'&&stat1=='pré-arbitrage'?returnedstat='pré-arbitrage accepté':
  stat=='pré-arbitrage acceptée'?returnedstat='pré-arbitrage accepté':
  stat=='pré-arbitrage rejetée'?returnedstat='pré-arbitrage rejeté':
  stat=='relancée'&&stat1=='pré-arbitrage rejetée'?returnedstat='pré-arbitrage rejeté':
  stat=='rejetée'&&stat1=='pré-arbitrage rejetée'?returnedstat='notification rejet pré-arb':
  //stat=='clôturé'&&stat1=='pré-arbitrage rejetée'?returnedstat='pré-arbitrage rejeté':
  stat=='arbitrage'?returnedstat='arbitrage reçu':
  stat=='arbitrage accepté'?returnedstat='arbitrage accepté':
  stat=='arbitrage rejeté'?returnedstat='arbitrage rejeté':
  stat=='Arbitrage Fav. acquéreur'?returnedstat='arbitrage gagné':
  stat=='Arbitrage fav. émetteur'?returnedstat='en cours':
  stat=='draft'?returnedstat='créée pas encore validée':

    'autre'
    :
  //statuts porteur
    user.usertype=='Clientpor'?
    stat=='crée'?returnedstat='créée':
    stat=='rejetée'&&stat1=='chb émis'?returnedstat='en cours':
    stat=='rejetée'&&stat1=='rejetée'?returnedstat='rejetée':
    stat=='rejetée'?returnedstat='rejetée':
    stat=='rechdoc'?returnedstat='en cours':
    stat=='reponserechdoc'?returnedstat='en cours':
    stat=='rejetée'&&stat1=='reponserechdoc'?returnedstat='Réponse demande de document':
    stat=='chb émis'?returnedstat='en cours':
    stat=='acceptée'?returnedstat='acceptée':
    stat=='clôturé'?returnedstat='clôturé':
    stat=='relancée'?returnedstat='relancée':
    stat=='pré-arbitrage'?returnedstat='en cours':
    stat=='pré-arbitrage acceptée'?returnedstat='acceptée':
    stat=='pré-arbitrage rejetée'?returnedstat='en cours':
    stat=='arbitrage'?returnedstat='en cours':
    stat=='arbitrage rejeté'?returnedstat='rejetée':
    stat=='arbitrage accepté'?returnedstat='acceptée':

    stat=='Arbitrage fav. émetteur'?returnedstat='acceptée':
    stat=='Arbitrage Fav. acquéreur'?returnedstat='en cours':
    stat=='draft'?returnedstat='créée pas encore validée':

    'autre'
    :
    //statuts émetteur
    eme==acq?
    stat=='crée'?returnedstat='créée':
    stat=='rechdoc'?returnedstat='Dde Doc émis':
    stat=='reponserechdoc'?returnedstat='Réponse dde doc reçue':
    stat=='acceptée'?returnedstat='acceptée':
    stat=='rejetée'?returnedstat='rejetée':
    stat=='clôturé'?returnedstat='clôturé':
    stat=='relancée'?returnedstat='relancée':
    stat=='draft'?returnedstat='créée pas encore validée':

  'autre'
    :
    //statuts émetteur
    eme?
    stat=='crée'?returnedstat='créée':
    stat=='rejetée'&&!stat1?returnedstat='rejetée':
    stat=='rejetée'&&stat1=='rechdoc'?returnedstat='recherche de documents rejetée':
    stat=='rejetée'&&stat1=='crée'?returnedstat='rejetée':
    stat=='rejetée'&&stat1=='chb émis'?returnedstat='Représentée':
    stat=='rejetée'&&stat1=='rejetée'?returnedstat='rejetée':
    stat=='rejetée'?returnedstat='rejetée':
    stat=='rechdoc'?returnedstat='Dde Doc émis':
    stat=='reponserechdoc'?returnedstat='Réponse dde doc reçue':
    stat=='rejetée'&&stat1=='reponserechdoc'?returnedstat='Réponse demande de document':
    stat=='chb émis'?returnedstat='chb émis':
    stat=='acceptée'&&stat1=='chb émis'?returnedstat='chb accepté':
 
  stat=='relancée'&&stat1=='rejetée'?returnedstat='relancée':
  //stat=='relancée'&&stat1=='relancée'?returnedstat='relancée':
  //stat=='clôturé'&&stat1=='relancée'&&stat2=='rejetée'?returnedstat='clôturé':
  stat=='clôturé'?returnedstat='clôturé':
  stat=='pré-arbitrage'&&stat1=='rejetée'&&stat2=='chb émis'||stat=='pré-arbitrage'&&stat1=='relancée'||stat=='pré-arbitrage'&&stat1=='pré-arbitrage'&&stat3=='rejetée'&&stat3=='chb émis'?returnedstat='pré-arbitrage émis':
  stat=='pré-arbitrage'?returnedstat='pré-arbitrage reçu':
  stat=='acceptée'&&stat1=='pré-arbitrage'?returnedstat='pré-arbitrage accepté':
  stat=='pré-arbitrage acceptée'?returnedstat='pré-arbitrage accepté':
  stat=='pré-arbitrage rejetée'?returnedstat='pré-arbitrage rejeté':
  stat=='rejetée'&&stat1=='pré-arbitrage rejetée'?returnedstat='notification rejet pré-arb':
  stat=='relancée'&&stat1=='pré-arbitrage rejetée'?returnedstat='relancée':
  stat=='arbitrage'&&stat1=='pré-arbitrage rejetée'&&role1=='émetteur'||stat=='arbitrage'&&stat1=='arbitrage'&&role1=='acquireur'?returnedstat='arbitrage reçu':
  stat=='arbitrage'?returnedstat='arbitrage émis':
  stat=='arbitrage accepté'?returnedstat='arbitrage accepté':
  stat=='arbitrage rejeté'?returnedstat='arbitrage rejeté':
  stat=='Arbitrage fav. émetteur'?returnedstat='arbitrage gagné':
  stat=='Arbitrage Fav. acquéreur'?returnedstat='arbitrage perdu':
  stat=='draft'?returnedstat='créée pas encore validée':

  'autre'
    :
    //statuts acquéreur
    acq?
    stat=='crée'?returnedstat='créée':
    stat=='rejetée'&&stat1=='crée'?returnedstat='rejetée':
    stat=='rejetée'&&stat1=='rechdoc'?returnedstat='recherche documents rejetée':
    stat=='rejetée'&&!stat1?returnedstat='rejetée':
    stat=='clôturé'?returnedstat='clôturé':
    stat=='rechdoc'?returnedstat='Dde Doc reçu':
    stat=='reponserechdoc'||stat=='relancée'&&stat1=='rejetée'&&stat2=='reponserechdoc'?returnedstat='Réponse dde doc émise':
    stat=='rejetée'&&stat1=='reponserechdoc'?returnedstat='Réponse demande de document':
    stat=='chb émis'?returnedstat='chb reçu':
    stat=='acceptée'&&stat1=='chb émis'?returnedstat='chb accepté':
    stat=='rejetée'&&stat1=='chb émis'?returnedstat='Représentée':
    stat=='rejetée'&&stat1=='rejetée'?returnedstat='rejetée':
 // stat=='clôturé'&&stat1=='relancée'&&stat2=='rejetée'?returnedstat='Représentée':
 stat=='pré-arbitrage'&&stat1=='chb émis'||stat=='pré-arbitrage'&&stat1=='preé-arbitrage'&&stat2=='chb émis'?returnedstat='pré-arbitrage émis':
  stat=='pré-arbitrage'?returnedstat='pré-arbitrage reçu':
  stat=='pré-arbitrage acceptée'?returnedstat='pré-arbitrage accepté':
  stat=='acceptée'&&stat1=='pré-arbitrage'?returnedstat='pré-arbitrage accepté':
  stat=='pré-arbitrage rejetée'?returnedstat='pré-arbitrage rejeté':
  stat=='relancée'&&stat1=='pré-arbitrage rejetée'?returnedstat='pré-arbitrage rejeté':
  stat=='rejetée'&&stat1=='pré-arbitrage rejetée'?returnedstat='notification rejet pré-arb':
  //stat=='clôturé'&&stat1=='pré-arbitrage rejetée'?returnedstat='pré-arbitrage rejeté':
  stat=='arbitrage'&&stat1=='pré-arbitrage rejetée'&&role1=='émetteur'||stat=='arbitrage'&&stat1=='arbitrage'&&role1=='acquireur'?returnedstat='arbitrage émis':
  stat=='arbitrage'?returnedstat='arbitrage reçu':
  stat=='arbitrage accepté'?returnedstat='arbitrage accepté':
  stat=='arbitrage rejeté'?returnedstat='arbitrage rejeté':
  stat=='Arbitrage Fav. acquéreur'?returnedstat='arbitrage gagné':
  stat=='Arbitrage fav. émetteur'?returnedstat='arbitrage perdu':
  stat=='draft'?returnedstat='créée pas encore validée':

  'autre'
  :'autre fois'
    return returnedstat
  }
}